module.exports = __webpack_public_path__ + "static/media/18c-08_ST-2018-244x366cm-oleo-sobre-madera.601bafb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18c/18c-08_ST-2018-244x366cm-oleo-sobre-madera.jpg
// module id = 235
// module chunks = 0